import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

class AdminTableBaseComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPagination: false,
            currentUrl: props.parsedUrl.href,
            list: null,
        };

        this.NOT_AVAILABLE = 'N/A';
        this.DEFAULT_PAGE = 0;
        this.DEFAULT_PAGE_SIZE = 25;
    }

    dateFormatter(cell) {
        return `${moment(cell).format('MM-DD-YYYY')}`;
    }

    linkComponent({ title, toPath, cellValue }) {
        return (
            <Link title={title} to={toPath}>
                {cellValue}
            </Link>
        );
    }
}

export default AdminTableBaseComponent;



// WEBPACK FOOTER //
// ./src/containers/tables/AdminTableBaseComponent.js